import { GroupedPaymentList, PaymentDetail } from "../types-interfaces/interfaces";
import { GroupedPaymentModel, PaymentModelDetail } from "../types-interfaces/types";

function getRowData(rowData: PaymentDetail | GroupedPaymentList, isGrouped: boolean | undefined, isDetail: boolean | undefined):Array<{colName:string,colValue:string}> {
  let newRowData = new Array<{colName:string,colValue:string}>();
  if (rowData){
    (Object.keys(rowData) as (keyof typeof rowData)[]).forEach((key) => {
      if (key.toString() === "id"){
        return;
      }
      let val = rowData[key];      
      newRowData.push(({colName:key.toString(),colValue: (val ? val.toString() : ' ')}));
    });
  }
  if (isGrouped){    
    newRowData[0].colValue = '';
    newRowData.splice(newRowData.length-1,1);    
  }
  if (isDetail){
    newRowData.splice(0,1);
    newRowData.splice(newRowData.length-1,1);
  }
  return newRowData;
}

function filterData<T>(data:Array<T> | undefined, filter: string):Array<T>{
  let newArray = new Array<T>();
  data && data.forEach((row) => {
    if (row){
      for(let key of (Object.keys(row) as (keyof typeof row)[])){
        let val = row[key];
        if (val && val.toString().toUpperCase().includes(filter.toUpperCase())){
          newArray.push(row);
          break;
        }
      }
    }
  });

  return newArray;
}

function filterGroupedPayment(data:Array<GroupedPaymentModel> | undefined, filter: string):Array<GroupedPaymentModel>{
  if (!filter || filter === ""){    
    return data ?? [];
  }

  let newArray: Array<GroupedPaymentModel> = [];

  if (data){
    data.forEach((row) => {
      let newDetail: Array<PaymentModelDetail> = [];
      let isMatchingRow = false;

      for(let key of (Object.keys(row) as (keyof typeof row)[])){
        let val = row[key];
        if (val && val.toString().toUpperCase().includes(filter.toUpperCase())){
          isMatchingRow = true;        
        }

        if (key === 'detail'){          
          (val as Array<PaymentModelDetail>).forEach((det: PaymentModelDetail) => {            
            if (JSON.stringify(det).toString().toUpperCase().includes(filter.toUpperCase())){
              newDetail.push(det);
            }
          })
        }

      }

      if (isMatchingRow || newDetail.length > 0){
        row.detail = (newDetail.length > 0) ? newDetail : row.detail;
        newArray.push(row);
      }
    })
  }

  return newArray;
}

function getHeaders<T extends {}>(element:T, columnName: Array<{name:string,value:string}>, isDetail?: boolean ):Array<string>{   
  if (!element){
    return [];
  }
  let result = (Object.keys(element) as (keyof typeof element)[]);
  let headers:Array<string> = [];
  result.forEach((header) => {    
    if ((isDetail && header.toString() !== 'collectionId' && header.toString() !== 'id' && header.toString() !== 'index') ||
        (!isDetail && header.toString() !== 'id' && header.toString() !== 'collectionId' && header.toString() !== 'detail')
    ){
      headers.push(columnName.find(h => h.name === header)?.value ?? header.toString());
    }
  });
  return headers;
}

/* Fix para select con múltiples values iguales */
const concatSeparator = "@";

function concatValue (value: number, toku?: string) {
  const concat = toku !== undefined ? `${concatSeparator}${toku}` : '';
  return `${value}${concat}`;
}

function splitValue (concat: string) {
  return concat.split(concatSeparator);
}

export { getRowData, filterData, getHeaders, concatValue, splitValue, filterGroupedPayment  }